
















































import Vue from 'vue';
import { ScheduleMsg, textToHtml } from '../../../models/ScheduleMsg';
import scheduleRuleVuex from '../../../vuex/common';

export default Vue.extend({
  mixins: [scheduleRuleVuex],
  props: {
    scheduleMsg: {
      type: Object as () => ScheduleMsg,
    },
    cardInfo: {
      type: Object,
    },
  },
  computed: {
    tranProps(): any[] {
      const temp = JSON.parse(JSON.stringify(this.props));
      return temp.map((p: any) => {
        if (p.builtIn) {
          p.fieldName = '\\${' + p.fieldName + '}';
        } else {
          p.fieldName = '\\${privateProps.' + p.fieldName + '}';
        }
        return p;
      });
    },
    newsSnap(): any {
      const news = this.scheduleMsg && this.scheduleMsg.WxNews;
      if((news as any).thumb) {
        return news;
      } else {
        let snap0 = news.snapshot[0];
        if(!snap0.thumb) {
          snap0 = {
            subject: snap0.title,
            thumb: snap0.picurl,
            gmtCreate: snap0.gmtCreate,
          };
        }
        return snap0;
      }
    },
    textHtml(): string {
      const wxText = this.scheduleMsg.WxText;
      const r = textToHtml(wxText.text, this.tranProps);
      return r;
    },
  },
});
